import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M8.25 0h-6.5A1.75 1.75 0 0 0 0 1.75v6.5A1.75 1.75 0 0 0 1.75 10h6.5A1.75 1.75 0 0 0 10 8.25v-6.5A1.75 1.75 0 0 0 8.25 0m.25 8.25a.25.25 0 0 1-.25.25H6.375l1-.75a.625.625 0 0 0-.75-1l-1 .75V5.908A1.87 1.87 0 0 0 7 4.155V2.808a.333.333 0 0 0-.482-.275L5 3.233l-1.518-.7A.333.333 0 0 0 3 2.808v1.347a1.87 1.87 0 0 0 1.375 1.753V7.5l-1-.75a.625.625 0 1 0-.75 1l1 .75H1.75a.25.25 0 0 1-.25-.25v-6.5a.25.25 0 0 1 .25-.25h6.5a.25.25 0 0 1 .25.25Z"
    }, null, -1)
  ]));
}
const imagePictureFlower = { render };
export {
  imagePictureFlower as default,
  render
};
//# sourceMappingURL=image-picture-flower.svg.js.map
